module.exports = __webpack_public_path__ + "static/media/ovelia1.bad33dfa.png";